import React from 'react';
import PropTypes from 'prop-types';
import { FieldInputProps } from '../../Constants/ReduxFormPropTypes';

const VenueCodeField = ({ input, className, maxLength, type }) => (
  <input
    {...input}
    id={input.name}
    type={type}
    className={className}
    maxLength={maxLength}
  />
);
VenueCodeField.propTypes = {
  input: FieldInputProps.isRequired,
  className: PropTypes.string.isRequired,
  maxLength: PropTypes.string.isRequired,
  type: PropTypes.string,
};
VenueCodeField.defaultProps = {
  type: 'text',
};

export default VenueCodeField;
